import { Grid, MenuItem, Select } from '@material-ui/core'
import React, { useCallback } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { createStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import constant from '../../../../constants/constants'
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined'
import { useState } from 'react'
import { useAuthContext } from '..'
import { useUpdateLangaugePreferenceMutation } from '../../../../api/organization.models'

export const contrast = {
  primary: '#e4f6ed',
  secondary: '#ffffff',
  greyText: '#888888',
}

export const useStyles = makeStyles(() =>
  createStyles({
    select: {
      color: contrast.secondary,
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
      '& .MuiOutlinedInput-input.MuiInputBase-input': {
        paddingRight: 30,
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    icon: {
      fill: contrast.primary,
    },
    box: {
      paddingLeft: 60,
    },
  }),
)

const { LANGUAGES } = constant

export const LanguageSelection: React.FC = React.memo(() => {
  const { i18n } = useTranslation('common')
  const { userLanguage } = useAuthContext()
  const [languageSelected, setLanguageSelected] = useState<string>('')
  const classes = useStyles()

  const [updateLangPref] = useUpdateLangaugePreferenceMutation()

  const changeLang = useCallback(
    (lng: string) => {
      updateLangPref({
        variables: {
          lang: lng,
        },
      })
      setLanguageSelected(lng)
      i18n.changeLanguage(lng)
    },
    [languageSelected],
  )

  /* useEffect(() => {
    if (!languageSelected && userLanguage) {
      setLanguageSelected(userLanguage)
      i18n.changeLanguage(userLanguage)
    }
  }, [userLanguage]) */

  return (
    <>
      <Grid item xs lg={2} />
      <LanguageOutlinedIcon fontSize="medium" />

      <Select
        className={classes.select}
        variant={'outlined'}
        onChange={({ target }) => changeLang(target.value as string)}
        value={!languageSelected ? userLanguage ?? '' : languageSelected}
        inputProps={{
          classes: {
            icon: classes.icon,
          },
        }}
      >
        {LANGUAGES.map((l) => {
          return (
            <MenuItem key={l} value={l}>
              {l.toUpperCase()}
            </MenuItem>
          )
        })}
      </Select>
    </>
  )
})
LanguageSelection.displayName = 'LanguageSelection'

export default LanguageSelection
